import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initMetaPixel } from './utils/metaPixel';
initMetaPixel();
render(<App data-id="element-330" />, document.getElementById('root'));